import type { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";

export interface PageSectionProps extends HTMLAttributes<HTMLDivElement> {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

export function PageSection({
  title,
  subtitle,
  actions,
  className,
  children,
  ...props
}: PageSectionProps) {
  return (
    <section className={cn("space-y-3", className)} {...props}>
      {(title || subtitle || actions) && (
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div>
            {title && <h2 className="text-xl font-semibold">{title}</h2>}
            {subtitle && <p className="text-sm text-muted">{subtitle}</p>}
          </div>
          {actions && <div className="flex gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

export default PageSection;
